import { render, staticRenderFns } from "./ItalicTextIcon.vue?vue&type=template&id=60f688d7&scoped=true"
import script from "./ItalicTextIcon.vue?vue&type=script&lang=js"
export * from "./ItalicTextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f688d7",
  null
  
)

export default component.exports